module.exports = __webpack_public_path__ + "static/media/checkbox-outline.671608b9.svg";